import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Navigation } from 'swiper/modules';

const Topslider = () => {
  return (
    <>
      <Swiper navigation={true} modules={[Navigation, Autoplay]} autoplay={{
        delay: 8000,
        disableOnInteraction: true,
      }} loop={true} speed={2000}
        className="mySwiper">

        <SwiperSlide className='my'><a href="#">퍼퓸핸드 30/40mL 구매 시 '퍼퓸드 핸드워시 카모 3mL*3' 증정</a></SwiperSlide>
        <SwiperSlide className='my'><a href="#">토일렛 프래그런스 세이지마리 구매 시 '토일렛 프래그런스 오브제 세트' 증정</a></SwiperSlide>
        <SwiperSlide className='my'><a href="#">전제품 구매 시 '샤워리바디 워시&로션 FOG 샘플' 증정</a></SwiperSlide>

      </Swiper>
    </>
  )
}

export default Topslider